import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { routeActions } from 'react-router-redux'
import ConsentsEditContent from './ConsentsEditContent'
import * as consentActions from 'services/consents/actions'

const mapStateToProps = () => {
  return {}
}

const mapDispatchToActions = {
  ...consentActions,
  navigateTo: routeActions.push,
}

export class ConsentsEditMobile extends React.Component {

  static propTypes = {
    stageUnconsenteList: PropTypes.func,
    navigateTo: PropTypes.func,
  }

  handleSubmit = (values) => {
    this.props.stageUnconsenteList(values)
    window.location.href = '/mobile/privacy_center/consents/decline'
  }

  render () {
    return (
      <div className='consentspage mobile'>
        <ConsentsEditContent onSubmit={this.handleSubmit} />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(ConsentsEditMobile)



// WEBPACK FOOTER //
// ./src/components/privacy_center/consents-edit/ConsentsEditMobile.jsx